import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import FrontOrderReturnList from '../entities/back-shopeeorderreturn'
import appconst from '@/lib/appconst';


interface OrderReturnState extends ListState<FrontOrderReturnList> {
    FrontOrderReturnList: FrontOrderReturnList,
}

class BackOrderReturn extends ListMutations<FrontOrderReturnList>{

}
class FrontOrderReturn extends ListModule<OrderReturnState, any, FrontOrderReturnList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<FrontOrderReturnList>(),
        loading: false,
        orderReturnInfo: FrontOrderReturnList,


    }
    actions = {
        async getAll(context: ActionContext<OrderReturnState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontShopeeOrderReturn/GetUserShopeeOrderReturnList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<FrontOrderReturnList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async editOrderReturn(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontShopeeOrderReturn/Update', payload.data);
        },
        async createOrderReturn(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/FrontShopeeOrderReturn/CreateOrderReturn', payload.data);
        }
       
    };
    mutations = {
        setCurrentPage(state: OrderReturnState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: OrderReturnState, pagesize: number) {
            state.pageSize = pagesize;
        },
    };
}

const frontorderreturn = new FrontOrderReturn();
export default frontorderreturn;